import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { API_HOST } from '@/config';
import { useToast } from '@/hooks/useToast';
import { ErrorMessage, extractServerErrorMsg, SURVEYS_QUERY_KEY } from '@/queries';
import { queryClient } from '@/reactQueryClient';
import client, { ApiRoutes } from '@/store/client';
import { Survey, CreateOrUpdateSurveyRequest } from '../types';

export const useCreateSurvey = () => {
  const { toast } = useToast();

  const createSurveyMutation = useMutation(
    ({ featureId, survey }: CreateOrUpdateSurveyRequest) => {
      return client.post<Survey>(
        `${API_HOST}/${ApiRoutes.Surveys}/${featureId}/surveys`,
        survey,
      );
    },
    {
      onError: (errorResponse: AxiosError) => {
        toast(extractServerErrorMsg(errorResponse, 'Failed to create survey.'), {
          variant: 'error',
        });
      },
      onSuccess: (_, { featureId }) => {
        queryClient.invalidateQueries([SURVEYS_QUERY_KEY, featureId]);
        toast('Survey created successfully.', {
          variant: 'success',
        });
      },
    },
  );

  const { mutateAsync: createSurvey, isLoading, error } = createSurveyMutation;
  const serverErrors: ErrorMessage[] = error?.response?.data?.errors || [];

  return { isLoading, serverErrors, createSurvey };
};
